import { Controller } from "@hotwired/stimulus"
import { toggle } from "el-transition"

export default class extends Controller {
  click(event) {
    // Ignore clicks from links or elements with the data-controller="dropdown"
    if (
      event.target.closest("a") ||
      event.target.closest('[data-controller="dropdown"]')
    )
      return

    const rowSelector = event.target.closest("tr").dataset.collapseSelector
    const elements = this.element.querySelectorAll(
      `[data-collapse-target="${rowSelector}"]`
    )
    elements.forEach((element) => {
      toggle(element)
    })
  }
}
